var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"language-flag d-inline-flex align-center"},[(_vm.showFlag)?_c('img',{staticClass:"lang-flag-img mr-1",attrs:{"src":_vm.flagSrc,"alt":_vm.code,"width":"20","height":"15","loading":"lazy"},on:{"error":function($event){_vm.showFlag = false}}}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }